import React from 'react'
import { Link } from 'react-router-dom'
import { MenuItem } from 'material-ui';
import { connect } from 'react-redux'

import language from '../config/language'

const Menu = ({ onClick, lang }) => {
  const {
    home,
    place,
    food,
    shopping,
    otop,
    hotels,
    news,
    bookmark,
    about
  } = language[lang].menu
  return  (
    <div>
      <MenuItem
        primaryText={home}
        containerElement={<Link to={'/'}/>}
        onClick={onClick}
        style={{ color: '#cfd8dc' }}
      />
      <MenuItem
        primaryText={news}
        containerElement={<Link to={'/home/news'}/>}
        onClick={onClick}
        style={{ color: '#cfd8dc' }}
      />
      <MenuItem
        primaryText={place}
        containerElement={<Link to={'/home/place'}/>}
        onClick={onClick}
        style={{ color: '#cfd8dc' }}
      />
      <MenuItem
        primaryText={shopping}
        containerElement={<Link to={'/home/shopping'}/>}
        onClick={onClick}
        style={{ color: '#cfd8dc' }}
      />
      <MenuItem
        primaryText={food}
        containerElement={<Link to={'/home/food'}/>}
        onClick={onClick}
        style={{ color: '#cfd8dc' }}
      />
      <MenuItem
        primaryText={hotels}
        containerElement={<Link to={'/home/hotels'}/>}
        onClick={onClick}
        style={{ color: '#cfd8dc' }}
      />
      <MenuItem
        primaryText={otop}
        containerElement={<Link to={'/home/otop'}/>}
        onClick={onClick}
        style={{ color: '#cfd8dc' }}
      />
      <MenuItem
        primaryText={'Map'}
        containerElement={<Link to={'/map'}/>}
        // onClick={onClick}
        style={{ color: '#cfd8dc' }}
      />
      <MenuItem
        primaryText={bookmark}
        containerElement={<Link to={'/bookmark'}/>}
        onClick={onClick}
        style={{ color: '#cfd8dc' }}
      />
      <MenuItem
        primaryText={about}
        containerElement={<Link to={'/about'}/>}
        // onClick={onClick}
        style={{ color: '#cfd8dc' }}
      />
    </div>
  )
}

export default connect(({ lang }) => ({ lang }))(Menu)



// WEBPACK FOOTER //
// ./src/template/Menu.js